module.exports = __webpack_public_path__ + "static/img/red_icon.5ef56bfd.png";